var wishlistProducts = [];
var wishlistProductsObj = {};
var isVariant = true;
class WishlistManager {
    constructor() {
        this.clickedStatus = 0;
        this.productId = null;
        this.variantId = null;
        this.productUrl = null;
        this.listId = null;
        this.sizeStatus = null;
        this.productStatus = false;
        this.shareDataObj = {};
        this.emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        this.shareListStatus = false;
        this.title = null;
        this.image = null;
        this.colorName = null;
        this.variantStatus = null;
        this.isUserStatus = false;
        this.controller = null;
        this.isRemove = false;
        // Initialize event listeners
        this.init();
    }

    init() {
        window.SwymCallbacks = [];
        window.SwymCallbacks.push(this.onSwymLoadCallback.bind(this));
        document.body.addEventListener("click", (event) => this.handleClick(event));
    }

    //  handle click event 
    handleClick(event) {
        if (event.target.classList.contains('customer_not_logged_in')) {
            this.userLoginPopup(event.target);
        } else if (event.target.classList.contains("swym-button") || (event.target.classList.contains("remove_wishlist") && !event.target.classList.contains("disabled"))) {
            this.productStatus = event.target.classList.contains("added") ? true : this.productStatus;
            if (event.target.classList.contains("remove_wishlist")) {
                this.productStatus = true;
                this.shareListStatus = false;
                this.isRemove = true;
                event.target.closest(".grid-item").remove();
                document.querySelectorAll(".remove_wishlist").forEach((item, index) => {
                    item.classList.add("disabled");
                });
            }
            if (event.target.closest("#ProductModals") && this.productStatus == false) {
                this.isRemove = true;
            }
            this.productId = event.target.dataset.productId;
            this.variantId = event.target.dataset.variantId;
            this.title = event.target.dataset.title;
            this.image = event.target.dataset.image;
            this.colorName = event.target.dataset.name;
            this.variantStatus = event.target.dataset.variantStatus;
            if (event.target.closest(".product-single__meta")) {
                let parentDiv;
                if (event.target.closest(".modal__inner")) {
                    parentDiv = "modal__inner";
                } else {
                    parentDiv = "product-single__meta";
                }
                this.changeVariantId(parentDiv);
            }
            this.productUrl = event.target.dataset.url;
            let productBlock = event.target.closest(".page-content--product");
            productBlock = productBlock 
                ? !!productBlock.querySelector(`.onload-select--size[data-variant-id="${this.variantId}"]`) 
                : false;


            this.sizeStatus = productBlock || event.target.dataset.page === "collection"
                ? event.target.dataset.status
                : true;

            if (this.sizeStatus == "true") {
                this.sizeStatus = true;
            }
            this.listId = document.getElementById("customer__id").dataset.id;
            this.clickedStatus = 1;
            isVariant = true;
            window.SwymCallbacks.push(this.onSwymLoadCallback.bind(this));
        } else if (event.target.classList.contains("swym-share-wishlist-email-btn")) {
                this.shareDataObj['name'] = document.querySelector("#swym-name").value,
                this.shareDataObj['email'] = document.querySelector("#swym-email").value,
                this.shareDataObj['note'] = document.querySelector("#swym-note").value
            if (this.allFieldsFilled(this.shareDataObj)) {
                if (this.emailPattern.test(this.shareDataObj.email)) {
                    document.querySelector(".email_error").classList.add("hidden");
                    this.shareListStatus = true;
                    this.clickedStatus = 1;
                    window.SwymCallbacks.push(this.onSwymLoadCallback.bind(this));
                } else {
                    document.querySelector(".email_error").classList.remove("hidden");
                }
            } else {
                document.querySelector(".swym-info-grey").classList.remove("hidden");
            }
        } else if (event.target.classList.contains("addToCart")) {
            let variantId = event.target.dataset.variantId;
            this.ajaxAddToCart(variantId, event.target);
        } else if (event.target.classList.contains("copy_link")) {
            this.copyShareLink(event.target);
        } else if (event.target.classList.contains("share_wishlist_popup") || event.target.classList.contains("klaviyo_popup")) {
            event.target.classList.add("hidden");
        } else if(event.target.getAttribute("name") === "Size" && event.target.getAttribute("checked") === "checked"){
            if(document.querySelector(".SWYM_quickView")){
                let SWYMWishlistButton = document.querySelector("#ProductModals .modal--quick-shop.modal--is-active.SWYM_quickView .main-product_wishlist");
                document.querySelector(".wishlist_product").innerHTML = 
                                            `<style>
                                                @keyframes spinnerWishlistLoader {
                                                    from {transform:rotate(0deg)}
                                                    to {transform:rotate(360deg)}
                                                }
                                              </style>
                                              <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#282828" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="
                                                  display: block;
                                                  margin-inline: auto;
                                                  margin-top: 6rem;
                                                  animation: spinnerWishlistLoader 1s infinite linear;
                                              ">
                                                <path d="M21 12a9 9 0 11-6.219-8.56"></path>
                                              </svg>`;
                setTimeout(function(){
                    SWYMWishlistButton.click();
                    document.querySelector("#ProductModals .modal--quick-shop.modal--is-active.SWYM_quickView").querySelector(".js-modal-close").click();
                },500);
            }
        }
    }

    userLoginPopup(button) {
        let title = button.dataset.title;
        let image = button.dataset.image;
        let msg = document.querySelector(".wishlist_content-wrapper").innerHTML;
        this.notifyTemplate(title, image, msg, 1);
        sessionStorage.setItem("productId", button.dataset.productId);
        sessionStorage.setItem("variantId", button.dataset.variantId);
        sessionStorage.setItem("productUrl", button.dataset.url);
        sessionStorage.setItem("colorName", button.dataset.name);
    }

    onSwymLoadCallback(swat) {
        if(swat && this.shareListStatus == true){
            this.shareWishlist(swat);
            this.shareListStatus = false;
            return ;
        }
        // swat && this.shareListStatus == true ? (this.shareWishlist(swat), null) : console.log();
        swat && this.clickedStatus === 0 ?
            this.listStatus(swat) :
            this.productStatus === true ?
            this.removeFromList(swat, this.listId, this.variantId, this.productId, this.productUrl) :
            this.addProductToList(swat, this.variantId, this.productId, this.listId, this.productUrl);
    }

    // check list status
    listStatus(swat) {
        let onSuccess = (lists) => {
            let emailId = null;
            var url = window.location.href;
            if(url.includes("lid") && !url.includes("Klaviyo")){
                url = url.split("lid=")[1].split("&")[0];
                this.fetchListDetails(swat, url);
                return ;
            }
            
            if (lists.length === 0) {
                this.createSwymList(swat);
            } else {
                if (document.getElementById("customer__id")) {
                    document.getElementById("customer__id").dataset.id = lists[0].lid;
                }
                let productId = sessionStorage.getItem("productId");
                let productUrl = sessionStorage.getItem("productUrl");
                let variantId = sessionStorage.getItem("variantId");
                if (productId && productUrl && variantId) {
                    this.isSize = false;
                    this.variantStatus = false;
                    this.colorName = sessionStorage.getItem("colorName");
                    this.isUserStatus = true;
                    this.addProductToList(swat, variantId, productId, lists[0].lid, productUrl);
                    sessionStorage.removeItem("productId");
                    sessionStorage.removeItem("productUrl");
                    sessionStorage.removeItem("variantId");
                    sessionStorage.removeItem("colorName");
                } else {
                    this.fetchListDetails(swat, lists[0].lid)
                }
                if (document.querySelector(".copy_link")) {
                    this.shareLink(swat, lists[0].lid);
                }
            }

            
        };

        let onError = (error) => {
            console.log("Error while fetching all Lists", error);
        };

        swat.fetchLists({
            callbackFn: onSuccess,
            errorFn: onError
        });
    }

    // get list data
    fetchListDetails(swat, lid) {
        let listConfig = {
            "lid": lid
        };

        let onSuccess = (listContents) => {
            if(document.querySelector(".shared_by")){
              document.querySelector(".shared_by").innerHTML = listContents[0].cby;
              document.querySelector(".shared_by_msg").classList.remove("hidden");
            }
            for (let listData of listContents) {
                if(listData.cprops.isSize == 'false'){
                    isVariant = false;
                }
            }
            
            this.preSelectWishlist(listContents);
        };

        let onError = (error) => {
            console.log("Error fetching List Contents", error);
        };

        swat.fetchListCtx(listConfig, onSuccess, onError);
    }
    
    fetchListForVariantStatus(swat, lid){
        let listConfig = {
            "lid": lid
        };

        let onSuccess = (listContents) => {
            for (let listData of listContents) {
                if(listData.cprops.isSize == 'false'){
                    isVariant = false;
                }
            }
        };

        let onError = (error) => {
            console.log("Error fetching List Contents", error);
        };

        swat.fetchListCtx(listConfig, onSuccess, onError);
    }
    // create swym list
    createSwymList(swat) {
        let listConfig = {
            "lname": "My Wishlist"
        };

        let onSuccess = (newList) => {
            let productId = sessionStorage.getItem("productId");
            let productUrl = sessionStorage.getItem("productUrl");
            let variantId = sessionStorage.getItem("variantId");
            if (productId && productUrl && variantId) {
                this.isSize = false;
                this.variantStatus = false;
                this.colorName = sessionStorage.getItem("colorName");
                this.isUserStatus = true;
                this.addProductToList(swat, variantId, productId, newList.lid, productUrl);
                sessionStorage.removeItem("productId");
                sessionStorage.removeItem("productUrl");
                sessionStorage.removeItem("variantId");
                sessionStorage.removeItem("colorName");
            }
        };

        let onError = (error) => {
            console.log("Error while creating a List", error);
        };

        swat.createList(listConfig, onSuccess, onError);
    }

    // add product to the list
    addProductToList(swat, variantId, productId, listId, productUrl) {
        if (this.controller) {
            this.controller.abort()
        }
        if (wishlistProductsObj.hasOwnProperty(productId)) {
            this.removeFromList(swat, listId, wishlistProductsObj[productId], productId, productUrl)
        }
        this.controller = new AbortController();

        let product = {
            epi: variantId,
            empi: productId,
            du: productUrl,
            cprops: {
                isSize: this.sizeStatus,
                colorName: this.colorName,
                variantStatus: this.variantStatus
            }
        };
        let onSuccess = (addedListItem) => {

            wishlistProductsObj[Number(addedListItem.empi)] = Number(addedListItem.epi);
            wishlistProducts.push(Number(addedListItem.epi));
            if (document.querySelectorAll(`button[data-variant-id="${addedListItem.epi}"]`).length > 0) {
                document.querySelectorAll(`button[data-variant-id="${addedListItem.epi}"]`).forEach((item, index) => {
                    item.classList.add("added");
                    if (item.classList.contains("product_wishlist")) {
                        item.innerHTML = ` <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 26.5 25.01" height="20" width="20">
                                                <defs>
                                                    <style>
                                                    .st0 {
                                                        fill: #282828;
                                                    }
                                                    </style>
                                                </defs>
                                                <path class="st0" d="M19.51,0c-2.61,0-4.69,1.47-6.21,2.92-1.26-1.42-2.76-2.92-5.87-2.92C3.83,0,0,2.89,0,8.25c0,7.19,12.38,16.44,12.51,16.53.22.16.48.24.73.24s.52-.08.74-.24c.12-.09,12.52-9.33,12.52-16.52,0-5.17-2.61-8.25-6.99-8.25Z"/>
                                                </svg>
                                            Added to Wishlist`
                    }
                });
            }
            if (document.querySelector(`.color-swatch[data-product-id="${addedListItem.empi}"]`)) {
                document.querySelector(`.color-swatch[data-product-id="${addedListItem.empi}"]`).classList.add("added");
            }
            let title = this.title;
            let image = this.image;
            let msg = `<strong>${this.title}</strong> has been added to wishlist.`;
            this.notifyTemplate(title, image, msg, 0);

            this.productStatus = false;
            // if (this.isUserStatus) {
            this.fetchListDetails(swat, listId);
            // }

            this.controller = null;
        };

        let onError = (error) => {
            console.log("Error while adding the Product to the List", error);
            this.controller = null;
        };

        swat.addToList(listId, product, onSuccess, onError, {
            signal: this.controller.signal
        });
    }

    notifyTemplate(title, image, msg, visibilityStatus) {
        if (title == null || image == null) {
            return;
        }
        const addedModalTemplate = `
                <a href='/account#wishlist' class="swym-added-product-media"> 
                    <img src="${image}" width="70" height="70" alt="${title}" /> 
                </a> 
                <a href='/account#wishlist' class="swym-added-product-content"> 
                    <span>${msg}</span> 
                </a> 
                <div class="close-product-added-modal"> 
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none"> 
                        <path d="M16 8L8 16M8.00001 8L16 16" stroke="#282828" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> 
                    </svg> 
                </div> 
            `;

        const modalContainer = document.createElement('div');
        modalContainer.className = 'swym-added-product-to-list';
        modalContainer.innerHTML = addedModalTemplate;

        if (document.querySelector('.swym-added-product-to-list')) {
            document.querySelector('.swym-added-product-to-list').remove();
        }
        document.body.appendChild(modalContainer);

        // Add event listener to close button 
        document.querySelector('.close-product-added-modal').addEventListener('click', function() {
            document.querySelector('.swym-added-product-to-list').remove();
        });
        if (visibilityStatus == 0) {
            setTimeout(function() {
                const modal = document.querySelector('.swym-added-product-to-list');
                if (modal) {
                    modal.remove();
                }
            }, 5000);
        }
    }
    //  to remove the product from the list
    removeFromList(swat, listId, variantId, productId, productUrl) {
        if (this.controller) {
            this.controller.abort()
        }

        this.controller = new AbortController();

        let product = {
            epi: variantId,
            empi: productId,
            du: productUrl
        };
        let onSuccess = (deletedProduct) => {
            delete wishlistProductsObj[deletedProduct.epi];
            wishlistProducts = wishlistProducts.filter(item => item !== deletedProduct.epi);
            let button = document.querySelectorAll(`button[data-variant-id="${deletedProduct.epi}"]`);
            if (button.length > 0) {
                button.forEach((item, index) => {
                    item.classList.remove("added");
                    if (item.classList.contains("product_wishlist")) {
                        item.innerHTML = `<svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 26.5 25.01" height="20" width="20">
                                            <defs>
                                                <style>
                                                .st0 {
                                                    fill: #231f20;
                                                }
                                                </style>
                                            </defs>
                                            <path class="st0" d="M19.51,0c-2.61,0-4.69,1.47-6.21,2.92-1.26-1.42-2.76-2.92-5.87-2.92C3.83,0,0,2.89,0,8.25c0,7.18,12.38,16.44,12.51,16.53.22.16.48.24.73.24s.52-.08.74-.24c.13-.09,12.52-9.32,12.52-16.52,0-5.17-2.61-8.25-6.99-8.25ZM13.24,22.19c-2.89-2.29-10.74-9.29-10.74-13.94,0-3.77,2.48-5.75,4.93-5.75,2.19,0,3.05.99,4.24,2.35.22.25.44.5.67.75.24.26.57.4.92.4h0c.35,0,.68-.15.92-.4,1.22-1.33,3.1-3.1,5.34-3.1,3.71,0,4.49,3.13,4.49,5.75,0,4.6-7.69,11.51-10.76,13.94Z"/>
                                        </svg>
                                        Add to Wishlist`
                    }
                })
            }
            if (document.querySelector(`.color-swatch[data-product-id="${deletedProduct.empi}"]`)) {
                document.querySelector(`.color-swatch[data-product-id="${deletedProduct.empi}"]`).classList.remove("added");
            }
            if (document.querySelector(".wishlist_product") != null && document.querySelector(".wishlist_product").childElementCount == 0) {
                document.querySelector(".wishlist_product").innerHTML = `<h4>${document.querySelector(".empty_wishlist").innerText}</h4>`;
            }
            this.productStatus = false;

            this.controller = null;
            if (this.isRemove == false) {
                this.fetchListDetails(swat, listId);
            } else {
                document.querySelectorAll(".remove_wishlist").forEach((item, index) => {
                    item.classList.remove("disabled");
                });
                this.fetchListForVariantStatus(swat, listId);
            }
            this.isRemove = false;
        };

        let onError = (error) => {
            console.log("Error while deleting the Product", error);
            this.controller = null;
        };

        swat.deleteFromList(listId, product, onSuccess, onError, {
            signal: this.controller.signal
        });
    }

    // pre select wishlist icon if product already in list
    preSelectWishlist(listContents) {
        var cartProducts = [],
            colorNameMsg;
        if (listContents.length == 0 && document.querySelector(".wishlist_product")) {
            document.querySelector(".wishlist_product").innerHTML = `<h4>${document.querySelector(".empty_wishlist").innerText}</h4>`;
            return;
        }
        for (let listData of listContents) {
            wishlistProductsObj[listData.empi] = listData.epi;
            wishlistProducts.push(listData.epi);
            if (document.querySelectorAll(`button[data-variant-id="${listData.epi}"]`).length > 0) {
                document.querySelectorAll(`button[data-variant-id="${listData.epi}"]`).forEach((item, index) => {
                    item.classList.add("added");
                    if (item.classList.contains("product_wishlist")) {
                        item.innerHTML = `  <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 26.5 25.01" height="20" width="20">
                                                <defs>
                                                    <style>
                                                    .st0 {
                                                        fill: #282828;
                                                    }
                                                    </style>
                                                </defs>
                                                <path class="st0" d="M19.51,0c-2.61,0-4.69,1.47-6.21,2.92-1.26-1.42-2.76-2.92-5.87-2.92C3.83,0,0,2.89,0,8.25c0,7.19,12.38,16.44,12.51,16.53.22.16.48.24.73.24s.52-.08.74-.24c.12-.09,12.52-9.33,12.52-16.52,0-5.17-2.61-8.25-6.99-8.25Z"/>
                                            </svg>
                                            Added to Wishlist`
                    }
                });
            }
            if (document.querySelector(`.color-swatch[data-variant-id="${listData.epi}"]`)) {
                document.querySelector(`.color-swatch[data-variant-id="${listData.epi}"]`).classList.add("added");
            }
            if(listData.cprops.isSize == 'false'){
                isVariant = false;
            }
        }
        if (document.querySelector(".wishlist_product")) {
            document.querySelector("#accountWishlist").style.minHeight = document.querySelector("#accountWishlist").offsetHeight + "px";
            document.querySelector(".wishlist_product").innerHTML = "";
            this.fetchCartData().then(cartData => {
                // FIX: protect against undefined / empty cartData
                if (!cartData || !Array.isArray(cartData.items)) {
                    console.warn("Cart data missing or invalid:", cartData);
                    cartData = { items: [] }; // prevent crashes
                }
                for (let product of cartData.items) {
                    cartProducts.push(product.id);
                }
                for (let listData of listContents) {
                    if (listData.cprops.variantStatus == 'false') {
                        this.isProductAvailable(listData);
                    }
                    let isSize = listData.cprops.isSize;
                    let button, selectedVariantName, quickViewModal;
                    if (listData.cprops.colorName) {
                        colorNameMsg = listData.cprops.colorName.includes("Default") || listData.cprops.colorName.includes("$") 
                            ? "" 
                            : `in ${listData.cprops.colorName}`;
                    }                    
                    if (isSize === true) {
                        selectedVariantName = listData.vi;
                        if (cartProducts.includes(listData.epi)) {
                            button = `
                            <form method="post" action="/cart/add" id="WishlistAddToCart-template--${listData.epi}" accept-charset="UTF-8" class="product-single__form" enctype="multipart/form-data">
								<button type="button" data-variant-id="${listData.epi}" class="btn btn--full btn--primary">Added to cart</button>
								<input type="hidden" name="id" value="${listData.epi}" />
                            	<input min="1" style="display:none;" type="number" id="quantity" name="quantity" value="1"/>
                            </form>
							`;

                        } else {
                            button = `
                            <form method="post" action="/cart/add" id="WishlistAddToCart-template--${listData.epi}" accept-charset="UTF-8" class="product-single__form" enctype="multipart/form-data">
                               <button data-variant-title=" ${selectedVariantName}" data-title="${listData.product.dt}" data-image="${listData.product.iu}" type="button" data-variant-id="${listData.epi}" class="btn ${listData.cprops.variantStatus == "true" ? 'addToCart' : 'out_of_stock klaviyo_button_product'} btn--full add-to-cart btn--primary">${listData.cprops.variantStatus == "true" ? 'Add to cart' : 'Notify me when available'}</button>
                               <input type="hidden" name="id" value="${listData.epi}" />
                               <input min="1" style="display:none;" type="number" id="quantity" name="quantity" value="1"/>
                            </form>
                            `;
                        }
                    } else {
                        selectedVariantName = "";
                        button = `
                    <a href="${listData.du}" class="grid-item__link js-no-transition">
                        <div class="btn btn--full add-to-cart btn--primary">
                            <span>Select a Size</span>
                        </div>
                    </a>`;
                        selectedVariantName = "";
                        button = `
                    <button class="wishlist_quickView grid-item__link quick-product__btn quick-product__btn--not-ready js-modal-open-quick-modal-${listData.empi}" title="Quick shop" data-handle="${listData.du.split("/products/")[1]}" aria-expanded="false">
                        <div class="btn btn--full select-size add-to-cart btn--primary">
                            <span>Select a Size</span>
                        </div>
                    </button>
                    `;
                        quickViewModal = `
                    <div id="QuickShopModal-${listData.empi}" class="modal modal--square modal--quick-shop" data-product-id="${listData.empi}">
                        <div class="modal__inner">
                            <div class="modal__centered">
                            <div class="modal__centered-content">
                                <div id="QuickShopHolder-${listData.du.split("/products/")[1]}"></div>
                            </div>

                            <button type="button" class="btn btn--circle btn--icon modal__close js-modal-close">
                                <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 64 64"><path d="m19 17.61 27.12 27.13m0-27.13L19 44.74" style="stroke-miterlimit:10"/></svg>
                                <span class="icon__fallback-text">Close (esc)</span>
                            </button>
                            </div>
                        </div>
                    </div>
                    `;
                    }

                    let wrapper = `
                    <div class="grid-item grid-product" data-product-handle="${listData.du.split("/products/")[1]}" data-image="${listData.product.iu}" data-variant-id="${listData.epi}" data-product-id="${listData.empi}" data-original-color data-active-swatch>
                        <div class="grid-item__content">
							${ (isSize === true && listData.cprops.variantStatus === 'false') ? '<span class="sold_out_tag">Sold out</span>' : ''}
                            <span class="remove_wishlist" data-variant-id="${listData.epi}" data-product-id="${listData.empi}" data-url="${listData.du}">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M16 8L8 16M8.00001 8L16 16" stroke="#282828" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                </svg>
                            </span>
                            <a href="${listData.cprops.isSize === true ? `${listData.du}?variant=${listData.epi}` : listData.du}">
                                <div class="grid-product__image-wrap" style="height: 0; padding-bottom: 100.0%;">
                                    <image-element> 
                                        <picture>
                                        <source fetchpriority="high" media="(min-width: 426px)" srcset="${listData.product.iu}">
                                        <source fetchpriority="high" media="(max-width: 425px)" srcset="${listData.product.iu}"> 
                                        <img data-image-id="${ listData.epi }" class="grid-product__image image-element" src="${listData.product.iu}" fetchpriority="high" loading="eager" style="opacity: 1;" alt="">
                                        </picture>
                                    </image-element>
                                </div>
                            </a>
                            <div class="grid-item__meta">
                                <a href="${listData.du}" class="grid-item__meta-main">
                                    <div class="grid-product__title">${listData.product.dt} ${colorNameMsg}</div>
                                    <span class="range_price">           
                                        <span aria-hidden="true">$${listData.product.pr}</span>
                                    </span>
                                </a>
                                <p class="selectedVariantName">${selectedVariantName != undefined ? selectedVariantName : ''}</p>
                            </div>
                            ${button}   
                        </div>                
                    </div>
                    ${quickViewModal != undefined ? quickViewModal : '' }
                `;
                    document.querySelector(".wishlist_product").innerHTML += wrapper;
                }
                document.querySelector("#accountWishlist").style.minHeight = "unset";
            });
        }

        if (!document.body.classList.contains("swym-loaded")) {
            document.body.classList.add("swym-loaded");
        }
        document.body.classList.add("wishlist-item_loaded");
    }
    async fetchCartData() {
        return fetch("/cart.js")
            .then(res => {
                if (!res.ok) {
                    throw new Error(`HTTP error! Status: ${res.status}`);
                }
                return res.json();
            })
            .catch(err => {
                console.log("Error:", err);
            });
    }
    changeVariantId(parentDiv) {
        let urlObj = new URL(window.location.href);
        let currentVariantId = urlObj.searchParams.get('variant');
        if (currentVariantId) {
            document.querySelectorAll(`.${parentDiv} .swym-button`).forEach((item, index) => {
                item.setAttribute("data-variant-id", currentVariantId);
            })
            this.variantId = currentVariantId;
        }
    }

    shareWishlist(swat) {
        // List ID You wish to email. 
        let lid = document.getElementById("customer__id").dataset.id;

        // information required to send the email
        let params = {
            toEmailId: this.shareDataObj.email,
            fromName: this.shareDataObj.name,
            note: this.shareDataObj.note,
            lid: lid,
        }
        // Success Callback.
        this.captureReceiverEmailKlaviyo(this.shareDataObj.email);
        let onSuccess = function(response) {
            document.querySelector(".share_wishlist_popup .popup-content").classList.add("hidden");
            document.querySelector('.share_wishlist_popup .popup-wishlist-wrapper').classList.add("share-wishlist-success");
        }

        // Error Callback.
        let onError = function(error) {
            console.log("There was an Error Sending the email", error);
        }

        // Send API 
        swat.sendListViaEmail(params, onSuccess, onError);
    }

    shareLink(swat, lid) {
        let onSuccess = (link, lid) => {
            document.querySelector(".copy_link").dataset.link = link;
            let platformShareUrlTemplate = `https://www.facebook.com/sharer.php?u=${link}`; // this is specific to platform, please look up your platform.
            document.querySelector(".swym-share-facebook").href = `https://www.facebook.com/sharer.php?u=${link}`;
            document.querySelector(".swym-share-twitter").href = `https://x.com/intent/post?url=${link}`;
        }
        let onError = (error) => {
            console.log("Error while generating the link", error)
        }

        swat.generateSharedListURL(lid, onSuccess, onError);
    }

    copyShareLink(currentTarget) {
        let shareLinkUrl = currentTarget.dataset.link;

        // Use Clipboard API to copy the text
        navigator.clipboard.writeText(shareLinkUrl)
            .then(() => {
                let title = "";
                let image = document.querySelectorAll(".wishlist_product .grid-item.grid-product")[0].dataset.image;
                let msg = `<strong>My Wishlist</strong> link copied to clipboard.`;
                this.notifyTemplate(title, image, msg, 0);
            })
            .catch(err => {
                console.error('Error copying text: ', err);
            });
    }
    ajaxAddToCart(variantId, targetBtn) {
        var addToCartForm = targetBtn.closest("form");
        var formData = new FormData(addToCartForm);
        var formObject = {};
        formData.forEach((value, key) => {
            formObject[key] = value;
        });
        targetBtn.innerText = "Adding...";
        fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formObject)
            })
            .then(response => response.json())
            .then(response => {
                targetBtn.innerText = "Added to cart";
                addToCartForm.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                    detail: {
                        product: response,
                        addToCartBtn: targetBtn
                    },
                    bubbles: true
                }));
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }
    // Function to check if all fields have a value
    allFieldsFilled(obj) {
        for (let key in obj) {
            if (obj[key].trim() === "") {
                return false; // If any field is empty, return false
            }
        }
        return true; // All fields are filled
    }

    async isProductAvailable(productJson) {
        let url = productJson.du + ".js";
        let variantId = productJson.epi;

        try {
            // Await the fetch call and response parsing
            let response = await fetch(url);
            let product = await response.json();

            // Find the selected variant
            let selectedVariant = product.variants.find(item => item.id === variantId);
            if (selectedVariant.available == true) {
                let button = document.querySelector(`button[data-variant-id='` + selectedVariant.id + `']`);
                button.classList.remove("out_of_stock", "klaviyo_button_product");
                button.classList.add("addToCart");
                button.innerHTML = "Add to cart";

                let imgTag = document.querySelector(`img[data-image-id='` + selectedVariant.id + `']`);
                imgTag.removeAttribute("style");
            }
            // Return true if available, else false
        } catch (error) {
            console.error("Error fetching product:", error);
            return false; // Return false if there’s an error
        }
    }

    captureReceiverEmailKlaviyo(receiverEmail){
        const options = {
            method: 'POST',
            headers: {revision: '2024-10-15.pre', 'content-type': 'application/vnd.api+json'},
            body: `{"data":{"type":"subscription","attributes":{"profile":{"data":{"type":"profile","attributes":{"subscriptions":{"email":{"marketing":{"consent":"SUBSCRIBED"}},"sms":{"marketing":{"consent":"SUBSCRIBED"},"transactional":{"consent":"SUBSCRIBED"}}},"email":"${receiverEmail}"}}}},"relationships":{"list":{"data":{"type":"list","id":"U4gLwj"}}}}}`
          };
          
          fetch('https://a.klaviyo.com/client/subscriptions?company_id=JDuuSU', options)
            .then(res => {return res;})
            .catch(err => console.error(err));
    }

}

// Initialize the WishlistManager
const wishlistManager = new WishlistManager();